import {AfterContentChecked, AfterViewChecked, ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {ExcTranslation} from 'exc-core';
import {ExcListComponent, ExcListConfig, OverlayConfig, OverlayRef} from 'exc-controls';
import {DefaultSettingsService} from '../../default-settings-service.service';
import {ExcRestService} from 'exc-rest';

@Component({
  selector: 'app-modal-review-group-edit-description',
  templateUrl: './modal-review-group-edit-description.component.html',
  styles: []
})
export class ModalReviewGroupEditDescriptionComponent extends ExcTranslation implements OnInit {

  candidates: any[] = [];
  listConfigDisplay: ExcListConfig = new ExcListConfig();
  searchValue: string = null;
  selectedAudits: any[] = [];
  step = 1;
  headerAudit: number = null;
  selectionForHeader: any[] = [];
  manualMode = false;
  groupHeader = '';
  groupText = '';
  previewObject: any = {};
  @ViewChild('lst') lst: ExcListComponent;
  constructor(private overlayRef: OverlayRef, private overlayConfig: OverlayConfig, private excDss: DefaultSettingsService, private excRest: ExcRestService, private cdr: ChangeDetectorRef) {
    super();
    const _self = this;
    _self.listConfigDisplay.showHeader = false;
    _self.listConfigDisplay.selectionMode = 'single';
    _self.listConfigDisplay.OnFocus = (focusItem, event?) => {
      _self.headerAudit = focusItem;
    };
    _self.listConfigDisplay.selectionMode = 'single';
    _self.listConfigDisplay.OnFocus = (focusItem, event?) => {
      _self.headerAudit = focusItem;
      _self.cdr.markForCheck();
      _self.cdr.detectChanges();
      _self.changeDisplayMode();
    };
  }

  ngOnInit() {
    const _self = this;
    _self.selectedAudits = _self.overlayConfig.data.PossibleAudits;
    Object.assign(_self.previewObject, _self.overlayConfig.data.PossibleAudits[0]);
    _self.previewObject.GroupAuditsRelated = _self.overlayConfig.data.PossibleAudits.length;
    _self.previewObject.AuditIsGroup = true;
    for (let i = 1; i < _self.selectedAudits.length; i++) {
      _self.previewObject.AuditTotalStock += _self.selectedAudits[i].AuditTotalStock;
      _self.previewObject.AuditFindings += _self.selectedAudits[i].AuditFindings;
      _self.previewObject.AuditFindingsCrit += _self.selectedAudits[i].AuditFindingsCrit;
      _self.previewObject.ReviewNonFinalItems += _self.selectedAudits[i].ReviewNonFinalItems;

    }
    if (_self.overlayConfig.data.Header.GroupHeader === null) {
      _self.manualMode = false;
      setTimeout(() => {
        for (const x of _self.selectedAudits) {
          if (x['AuditID'] === _self.overlayConfig.data.Header['AuditLead']) {
            _self.lst.focusItem(x);
            _self.headerAudit = x;
            _self.cdr.markForCheck();
            _self.cdr.detectChanges();
            break;
          }
        }
        _self.changeDisplayMode();
      }, 150);
    } else {
      _self.manualMode = true;
      _self.groupText = _self.overlayConfig.data.Header.GroupText;
      _self.groupHeader = _self.overlayConfig.data.Header.GroupHeader;
      _self.changeDisplayMode();
    }
    console.log(_self.previewObject);
  }
  changeDisplayMode() {
    if (this.manualMode === true) {
      this.previewObject.DealerName = this.groupHeader;
      this.previewObject.DealerZip = this.groupText;
      this.previewObject.DealerLevel1 = null;
      this.previewObject.DealerLevel2 = null;
      this.previewObject.DealerLevel3 = null;
      this.previewObject.DealerCountry = null;
      this.previewObject.DealerCity = null;
      this.previewObject.DealerRating = null;
    } else {
      if (this.headerAudit !== null) {
        this.previewObject.DealerName = this.headerAudit['DealerName'];
        this.previewObject.DealerZip = this.headerAudit['DealerZip'];
        this.previewObject.DealerLevel1 = this.headerAudit['DealerLevel1'];
        this.previewObject.DealerLevel2 = this.headerAudit['DealerLevel2'];
        this.previewObject.DealerLevel3 = this.headerAudit['DealerLevel3'];
        this.previewObject.DealerCountry = this.headerAudit['DealerCountry'];
        this.previewObject.DealerCity = this.headerAudit['DealerCity'];
        this.previewObject.DealerRating = this.headerAudit['DealerRating'];
      }
    }
  }
  getAvatarClass(data) {
    return data.AuditType === 16
      ? data.AuditIsPicked ? 'fa-mobile th-warning' : 'fa-mobile th-secondary'
      : data.AuditIsPicked ? 'fa-user-secret th-warning' : 'fa-user-secret th-secondary';
  }
  nextStep() {
    const _self = this;
    _self.overlayRef.close({proceed: true, Audits: _self.selectedAudits
      , AuditLead: (_self.manualMode === false ? _self.headerAudit['AuditID'] : null)
      , GroupHeader: (_self.manualMode === false ? null : _self.groupHeader)
      , GroupBody: (_self.manualMode === false ? null : _self.groupText) });
  }
  getBackButtonText() {
    return this.getGlobal('Cancel');
  }
  getNextButtonText() {
    return this.getGlobal('Save');
  }
  backStep() {
    this.overlayRef.close({proceed: false});
  }
}
